import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

export const Body6 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '18px', lineHeight: '24px' },
    { fontSize: '24px', lineHeight: '28px' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      {children}
    </BaseText>
  );
};
